import React, { useState, useRef } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReusableCheckbox from '../../components/common/ReusableCheckbox';
import UserService from '../../services/UserService';

const SignUp = () => {
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [redirectMsgVisible, setRedirectMsgVisible] = useState(false);
  const [dpaConsent, setDpaConsent] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    whatsAppNo: '',
    businessDetails: '',
    agreeToDPA: false,
    agreeToPromotionalEmails: false
  });

  const timeoutRef = useRef(null);
  const navigate = useNavigate();

  const handleFocus = () => {
    clearTimeout(timeoutRef.current);
    setIsPasswordFocused(true);
  };

  const handleBlur = () => {
    timeoutRef.current = setTimeout(() => {
      setIsPasswordFocused(false);
    }, 100);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      whatsAppNo: formData.whatsAppNo,
      businessDetails: formData.businessDetails,
      accountId: '91f3c6e5-f6bc-427d-b02d-b4fe515ace0b',
      isAgreeToDPA: formData.agreeToDPA,
      isAgreeToPromotionalEmails: formData.agreeToPromotionalEmails
    };
    try {
      await UserService.userRegistration(payload);
      navigate('/signin');
    } catch (error) {
  console.error('Registration failed:', error);
      // If using fetch
      if (error.response) {
        // For axios
        const apiMessage = error.response.data?.message || "Registration failed. Please try again.";
        alert(apiMessage);
      } else if (error.message) {
        // For native fetch or other errors
        alert(error.message);
      } else {
        alert("Registration failed. Please try again.");
      }
    }
  };

  return (
    <div className="d-flex flex-wrap p-4 bg-light" style={{ minHeight: '80vh' }}>
      {/* Left Section */}
      <div className="col-lg-6 p-4">
        <img
          src='/assets/images/reg-illustration.png'
          alt="Illustration"
          className="img-fluid mb-3 rounded"
          style={{ maxHeight: '400px' }}
        />
        <h5>🔐 Privacy First</h5>
        <p>Your email and number are safe with us — only used for updates and follow-ups.</p>

        <h5>🔒 We Respect Your Privacy</h5>
        <p>No spam. No sharing. Just important updates when you need them.</p>

        {isPasswordFocused && (
          <div
            className="p-3 mt-4 border rounded"
            style={{ borderColor: 'purple', borderStyle: 'dashed' }}
          >
            <h6>🛡️ Password rules</h6>
            <ul className="mb-0">
              <li>Should be at least 8 characters long</li>
              <li>Minimum one upper case</li>
              <li>Minimum one lower case</li>
              <li>At least one special character</li>
              <li>Confirm password and password should match</li>
            </ul>
          </div>
        )}
      </div>

      {/* Right Section */}
      <div className="col-lg-6 p-4 bg-white rounded shadow">
        <h2 className="fw-bold mb-2 d-flex align-items-center gap-2">
          Sign Up <img src='/assets/images/logo.png' alt="Logo" width="50" />
        </h2>

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>First Name *</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={formData.firstName}
                  onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.lastName}
                  onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                />
              </Form.Group>
            </Col>
          </Row>

          <div onFocus={handleFocus} onBlur={handleBlur}>
            <Form.Group className="mb-3">
              <Form.Label>Password *</Form.Label>
              <Form.Control
                type="password"
                required
                placeholder="Choose a strong password for security reason"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirm Password *</Form.Label>
              <Form.Control
                type="password"
                required
                placeholder="Should match with your password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              />
            </Form.Group>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>WhatsApp Number *</Form.Label>
            <div className="d-flex">
              <span className="input-group-text">+91</span>
              <Form.Control
                type="text"
                required
                value={formData.whatsAppNo}
                onChange={(e) => setFormData({ ...formData, whatsAppNo: e.target.value })}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Address *</Form.Label>
            <Form.Control
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="A little detail about yourself and/or your company..."
              value={formData.businessDetails}
              onChange={(e) => setFormData({ ...formData, businessDetails: e.target.value })}
            />
          </Form.Group>

          <ReusableCheckbox
            id="agreeToDPA"
            name="agreeToDPA"
            label="I agree to receive authentication (OTP) messages from ProspectPulse on my WhatsApp number."
            checked={formData.agreeToDPA}
            onChange={(e) => {
              setFormData({ ...formData, agreeToDPA: e.target.checked });
              setDpaConsent(e.target.checked);
            }}
          />

          <ReusableCheckbox
            id="agreeToPromotionalEmails"
            name="agreeToPromotionalEmails"
            label="I give consent to receive promotional and update emails from ProspectPulse."
            checked={formData.agreeToPromotionalEmails}
            onChange={(e) => {
              setFormData({ ...formData, agreeToPromotionalEmails: e.target.checked });
            }}
          />

          <Button
            type="submit"
            className="w-100 text-white fw-semibold"
            style={{ backgroundColor: '#CC5500', border: 'none' }}
            disabled={!dpaConsent}
          >
            Sign up
          </Button>
        </Form>
      </div>

      {/* Success Modal */}
      <Modal show={showSuccessPopup} centered>
        <Modal.Body className="text-center">
          <h5 className="text-success">✅ Registered successfully!</h5>
          {redirectMsgVisible && (
            <p className="text-muted mt-2">Redirecting you to login...</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SignUp;
